import React, { useMemo, useCallback } from 'react';
import RegistrosTableSection from './RegistrosTableSection';
import AlistamientosIndicadoresSection from './AlistamientosIndicadoresSection';
import { useRegistrosPeriodo } from '../../hooks/useRegistrosPeriodo';
import { getAlistamientos } from '@/pages/laundry/alistamientos/services/alistamientos.services';
import {
  alistamientosDataColumns,
  alistamientosExcelColumns,
  expandAlistamientosPorItem,
} from '@/pages/laundry/alistamientos/utils/alistamientosColumns';

// Reporte "Alistamientos": todos los alistamientos creados en el periodo, con las mismas
// columnas y el mismo Excel (una fila por prenda) que la pantalla de alistamientos, más
// indicadores y gráficas debajo. Los "Eliminado" (borrado lógico) no se incluyen.
const AlistamientosContent = ({ idLavanderia, dateRange, startDate, endDate }) => {
  const query = useMemo(
    () => ({ lavanderiaId: idLavanderia, fechaCreacion: dateRange, estado: { $ne: 'Eliminado' } }),
    [idLavanderia, dateRange],
  );
  const resetKey = JSON.stringify(query);

  const fetchPage = useCallback(
    async ({ page, limit }) => {
      const resp = await getAlistamientos({ query, page, limit });
      return { data: resp.data, totalRecords: resp.totalRecords };
    },
    [query],
  );

  const fetchAll = useCallback(async () => {
    const resp = await getAlistamientos({ query, page: 1, limit: 10000 });
    return resp.data;
  }, [query]);

  const registros = useRegistrosPeriodo({ fetchAll, resetKey });

  const exportService = useCallback(async () => expandAlistamientosPorItem(await fetchAll()), [fetchAll]);

  return (
    <div className="space-y-4">
      <RegistrosTableSection
        title="Alistamientos"
        columns={alistamientosDataColumns}
        fetchPage={fetchPage}
        resetKey={resetKey}
        exportService={exportService}
        exportColumns={alistamientosExcelColumns}
        exportFileName={`Alistamientos_${String(startDate).slice(0, 10)}_a_${String(endDate).slice(0, 10)}`}
      />
      <AlistamientosIndicadoresSection registros={registros} />
    </div>
  );
};

export default AlistamientosContent;
